
(function () {
  async function fetchMetafield(productId, variantId) {
    try {
      const metafieldRes = await fetch(`/admin/api/2024-04/variants/${variantId}/metafields.json`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const data = await metafieldRes.json();
      const metafield = data.metafields.find(mf =>
        mf.namespace === 'custom' && mf.key === 'price_history'
      );

      if (!metafield) return;

      const history = JSON.parse(metafield.value);
      if (!Array.isArray(history)) return;

      const last30Days = history.filter(entry => {
        const date = new Date(entry.date);
        const now = new Date();
        return (now - date) / (1000 * 60 * 60 * 24) <= 30;
      });

      const prices = last30Days.map(entry => entry.price);
      const minPrice = Math.min(...prices);

      const rawPriceText = document.querySelector("#ProductPrice")?.textContent || "";
      const variantPrice = parseFloat(rawPriceText.replace(/[^\d,]/g, "").replace(",", "."));

      if (minPrice && variantPrice && minPrice < variantPrice) {
        const el = document.createElement("div");
        el.innerHTML = `<strong>Prezzo più basso degli ultimi 30 giorni:</strong> €${minPrice.toFixed(2).replace(".", ",")}`;
        el.style.marginTop = "5px";
        el.style.fontSize = "14px";
        el.style.color = "#cc0000";

        const priceContainer = document.querySelector("#ProductPrice");
        if (priceContainer) {
          priceContainer.parentNode.insertBefore(el, priceContainer.nextSibling);
        }
      }
    } catch (error) {
      console.error("Errore nel recupero del prezzo minimo:", error);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const productIdMeta = document.querySelector("meta[name='product-id']");
    const variantIdInput = document.querySelector("input[name='id']");
    if (!productIdMeta || !variantIdInput) return;

    const productId = productIdMeta.getAttribute("content");
    const variantId = variantIdInput.value;

    fetchMetafield(productId, variantId);
  });
})();
